// Libraries
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Enums
import { BAR_VERTICAL, BAR_HORIZONTAL, PIE } from 'common/enums/chartTypes';
import { EngagementReportQuestionType } from 'engagementReport/enums/propTypes';

// Components
import MatrixVerticalBarChart from 'engagementReport/components/matrix/MatrixVerticalBarChart';
import MatrixHorizontalBarChart from 'engagementReport/components/matrix/MatrixHorizontalBarChart';
import MatrixPieCharts from 'engagementReport/components/matrix/MatrixPieCharts';

const renderChart = ({ chartType, data }, width) => {
  switch (chartType) {
    case BAR_HORIZONTAL:
      return <MatrixHorizontalBarChart data={data} width={width} />;
    case PIE:
      return <MatrixPieCharts data={data} />;
    case BAR_VERTICAL:
    default:
      return <MatrixVerticalBarChart data={data} />;
  }
};

const MatrixReport = ({ question }) => {
  const ref = useRef();
  const { t } = useTranslation();
  const [width, setWidth] = useState();
  const isEmpty = question.data.options.every((option) =>
    option.values?.every((value) => value.count === 0)
  );

  useEffect(() => {
    setWidth(ref.current?.getBoundingClientRect().width);
  }, []);

  return (
    <div className="matrix-report" ref={ref}>
      {isEmpty && (
        <div className="basic-report__subtitle">{t('engagement_report.no_responses')}</div>
      )}
      {!isEmpty && renderChart(question, width)}
    </div>
  );
};

MatrixReport.propTypes = {
  question: EngagementReportQuestionType.isRequired,
};

export default MatrixReport;
